import {
  browserTracingIntegration,
  feedbackIntegration,
  init,
  replayIntegration,
} from '@sentry/angular';
import { Environment } from '@nimmsta/ng-commons-lib';
import { environment } from '@environments/environment';
import { VERSION } from '@environments/version';

export const initSentry = () => {
  init({
    dsn: 'https://49eccb54d299cda1c1debb4ab18993b1@sentry.nimmsta.com/6',
    release: VERSION.fullHash,
    environment: (() => {
      switch (environment.environment) {
        case Environment.PROD: return 'production';
        case Environment.STAGING: return 'staging';
        case Environment.DEV: return 'development';
        default: return 'unknown';
      }
    })(),

    // PII
    sendDefaultPii: true,

    // Setup integrations
    integrations: [
      browserTracingIntegration({}),
      replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
      // ToDo: translation
      feedbackIntegration({
        autoInject: false,
        colorScheme: 'light',
        showBranding: false,
        formTitle: 'Report a problem with this page',
        messagePlaceholder: 'Please provide a description of the problem you encountered.',
        submitButtonLabel: 'Send feedback',
      }),
    ],
    beforeSend(event, hint) {
      // Filter out HTTP 0 errors
      if (
        hint?.originalException
        && typeof hint.originalException === 'string'
        && (hint.originalException as string).includes('0 Unknown Error')
      ) {
        return null;
      }

      return event;
    },

    // Tracing
    tracesSampleRate: environment.production ? 0.1 : 1.0,

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      // 'localhost',
      /^https:\/\/backend.*\.nimmsta\.com/,
      /^https:\/\/backend.*\.nimmsta-test\.de/,
      /^https:\/\/api\.nimmsta\.com/,
      /^https:\/\/api\.nimmsta-test\.de/,
    ],

    // Session Replay
    replaysSessionSampleRate: environment.production ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
};
